export class GoogleWorkspaceResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "userCount",
            "baseName": "userCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "sharedDriveCount",
            "baseName": "sharedDriveCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "gmailBytes",
            "baseName": "gmailBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "driveBytes",
            "baseName": "driveBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceResource.attributeTypeMap;
    }
    constructor() {
    }
}
